"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RewardsBtUpsellEntrypoint = exports.isSweepAddendumDocumentName = exports.SWEEP_ADDENDUM_DOCUMENT_NAMES = void 0;
const documentName_1 = require("../compliance/documentName");
/** The sweep addenda an offer can name: the standard supplement, or its promotional-APR variant. */
exports.SWEEP_ADDENDUM_DOCUMENT_NAMES = [documentName_1.DocumentName.BalanceTransferSweepAddendum, documentName_1.DocumentName.RewardsBtSweepPromoAddendum];
/** Whether a document is one of the sweep addenda, so each caller does not restate the pair. */
const isSweepAddendumDocumentName = (documentName) => exports.SWEEP_ADDENDUM_DOCUMENT_NAMES.includes(documentName);
exports.isSweepAddendumDocumentName = isSweepAddendumDocumentName;
/**
 * Which surface sent the customer into the Rewards BT Upsell flow. Stamped on every analytics event in the flow
 */
var RewardsBtUpsellEntrypoint;
(function (RewardsBtUpsellEntrypoint) {
    RewardsBtUpsellEntrypoint["postActivation"] = "postActivation";
    RewardsBtUpsellEntrypoint["postLoginGate"] = "postLoginGate";
    RewardsBtUpsellEntrypoint["inAppCard"] = "inAppCard";
    RewardsBtUpsellEntrypoint["balanceDetailsBeard"] = "balanceDetailsBeard";
})(RewardsBtUpsellEntrypoint || (exports.RewardsBtUpsellEntrypoint = RewardsBtUpsellEntrypoint = {}));
